import React from 'react';
import { BarChart3 } from 'lucide-react';
import MarkdownRenderer from '../common/MarkdownRenderer';

interface KeyFinding {
  primary_answer_breakdown: string;
  categorical_distribution: string;
}

interface KeyFindingsSummaryProps {
  finding: KeyFinding;
  totalRespondents?: number;
}

const KeyFindingsSummary: React.FC<KeyFindingsSummaryProps> = ({ finding, totalRespondents }) => {
  if (!finding) {
    return (
      <div className="text-sm text-gray-500">No key findings available</div>
    );
  }
  
  // Safety check for required fields
  if (!finding.primary_answer_breakdown && !finding.categorical_distribution) {
    return (
      <div className="text-sm text-gray-500">Key findings data is incomplete</div>
    );
  }
  
  return (
    <div className="space-y-4">
      {/* Single card containing both summary fields - matching AI Insights styling */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-4 transition-all duration-200 hover:shadow-sm">
        {/* Header with Icon - COMMENTED OUT FOR NOW */}
        {/* <div className="flex items-start gap-4">
          <div className="bg-[#E8FCFA] text-[#07E5D1] p-2.5 rounded-lg flex-shrink-0">
            <BarChart3 className="h-5 w-5" />
          </div>
          <div className="flex-1 space-y-4">
            <h4 className="font-semibold text-[#1C1C1E] text-base leading-snug">
              Statistical Summary
            </h4> */}
            
        <div className="space-y-4">
            {/* Primary Answer Breakdown */}
            {finding.primary_answer_breakdown && (
              <div>
                <p className="text-sm font-bold text-[#1C1C1E] uppercase mb-2">
                  Primary Answer Breakdown
                </p>
                <div className="text-sm text-[#374151]">
                  <MarkdownRenderer 
                    content={finding.primary_answer_breakdown}
                    variant="compact"
                  />
                </div>
              </div>
            )}
            
            {/* Categorical Distribution */}
            {finding.categorical_distribution && (
              <div>
                <p className="text-sm font-bold text-[#1C1C1E] uppercase mb-2">
                  Categorical Distribution
                </p>
                <div className="text-sm text-[#374151]">
                  <MarkdownRenderer 
                    content={finding.categorical_distribution}
                    variant="compact"
                  />
                </div>
              </div>
            )}
        </div>
        {/* </div>
        </div> */}
      </div>
    </div>
  );
};

export default KeyFindingsSummary;